import { Directive, Input, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[vpImagePlaceholder]',
    standalone: false
})
export class ImagePlaceholderDirective {
    private el = inject<ElementRef<HTMLImageElement>>(ElementRef);

    private readonly defaultPlaceholderSrc = '/assets/images/placeholder.png';

    @Input('vpImagePlaceholder') placeholderSrc: string;

    constructor() {
        this.el.nativeElement.onerror = () => {
            this.el.nativeElement.onerror = null;
            this.el.nativeElement.src = this.placeholderSrc || this.defaultPlaceholderSrc;
        };
    }
}
